import { Shape } from 'three'
import { Helper } from '../../../../../classes/helper'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'

interface Props {
  width: number
  height: number
}

export const FrontBarDefault = ({ width, height }: Props): JSX.Element => {
  const { userWidth } = useMeasures()
  const { color } = useRoof()

  const shape = new Shape()
    .moveTo(0, 0)
    .lineTo(-width, 0)
    .lineTo(-width, height)
    .lineTo(-width + 0.005, height)
    .lineTo(-width + 0.005, height - 0.002)
    .lineTo(-width + 0.002, height - 0.002)
    .lineTo(-width + 0.002, 0)
    .lineTo(0, 0.002)

  const extrudeSettings = {
    curveSegments: 1,
    steps: 1,
    depth: userWidth,
    bevelEnabled: false,
  }

  const shapeCap = new Shape()
    .moveTo(0.01, -0.001)
    .lineTo(-width, -0.001)
    .lineTo(-width, height)
    .lineTo(0.02, height - 0.008)
    .lineTo(0.02, 0.01)

  const extrudeCapSettings = {
    curveSegments: 1,
    steps: 1,
    depth: 0.005,
    bevelEnabled: false,
  }

  return (
    <>
      <mesh
        rotation={[0, Helper.convertAngleToRadiant(90), 0]}
        position={[-userWidth / 2, 0, 0]}
        castShadow={true}
      >
        <extrudeGeometry attach="geometry" args={[shape, extrudeSettings]} />
        <CachedMeshPhysicalMaterial color={color} />
      </mesh>
      {[...Array(2)].map((_, index) => {
        return (
          <mesh
            rotation={[0, Helper.convertAngleToRadiant(90), 0]}
            key={'FrontBarDefault' + index}
            position={[(-userWidth / 2) * (index ? 1.001 : -0.999), 0, 0]}
            castShadow={true}
          >
            <extrudeGeometry
              attach="geometry"
              args={[shapeCap, extrudeCapSettings]}
            />
            <CachedMeshPhysicalMaterial color={color} />
          </mesh>
        )
      })}
    </>
  )
}
